import { ComparisonType, ExpressionFunctionType, isValidBusinessObject } from '@iotv/iotv-v3-types';
import '@mui/lab';
const debug = process.env.REACT_APP_DEBUG && false;
export var AdjacentType;
(function (AdjacentType) {
  AdjacentType["PARENT"] = "matchedRelatedByPk";
  AdjacentType["CHILD"] = "matchedRelatedBySk";
  AdjacentType["SUBJECT"] = "matchedPrimary";
})(AdjacentType || (AdjacentType = {}));
export const isViewObject = x => x.matchedPrimary || x.matchedRelatedByPk instanceof Array && x.matchedRelatedByPk.every(isValidBusinessObject) || x.matchedRelatedBySk instanceof Array && x.matchedRelatedBySk.every(isValidBusinessObject);
export var LineChartXType;
(function (LineChartXType) {
  LineChartXType[LineChartXType["TIMESERIES"] = 0] = "TIMESERIES";
  LineChartXType[LineChartXType["INDEX"] = 1] = "INDEX";
  LineChartXType[LineChartXType["WEEK"] = 2] = "WEEK";
})(LineChartXType || (LineChartXType = {}));
export var ChartType;
(function (ChartType) {
  ChartType["Column"] = "Column";
  ChartType["Line"] = "Line";
  ChartType["Combo"] = "Combo";
})(ChartType || (ChartType = {}));
export var Unit;
(function (Unit) {
  Unit[Unit["Date"] = 0] = "Date";
  Unit[Unit["Meter"] = 1] = "Meter";
  Unit[Unit["Units"] = 2] = "Units";
})(Unit || (Unit = {}));
export var ObjectViewType;
(function (ObjectViewType) {
  ObjectViewType[ObjectViewType["Item"] = 0] = "Item";
  ObjectViewType[ObjectViewType["List"] = 1] = "List";
})(ObjectViewType || (ObjectViewType = {}));
export var UserTransactionType;
(function (UserTransactionType) {
  UserTransactionType["CREATE"] = "CREATE";
  UserTransactionType["UPDATE"] = "UPDATE";
  UserTransactionType["DELETE"] = "DELETE";
  UserTransactionType["LINK"] = "LINK";
  UserTransactionType["UNLINK"] = "UNLINK";
  UserTransactionType["REGISTER"] = "REGISTER";
  UserTransactionType["CREATE_AND_LINK"] = "CREATE_AND_LINK";
  UserTransactionType["IMPORT"] = "IMPORT";
})(UserTransactionType || (UserTransactionType = {}));
export var ComponentMode;
(function (ComponentMode) {
  /** 2024 Jan - create should allow edit and show variants on user, but suppress delete */
  ComponentMode[ComponentMode["CREATE"] = 0] = "CREATE";
  ComponentMode[ComponentMode["VIEW"] = 1] = "VIEW";
  ComponentMode[ComponentMode["EDIT"] = 2] = "EDIT";
  ComponentMode[ComponentMode["READONLY"] = 3] = "READONLY";
  ComponentMode[ComponentMode["NOEDIT"] = 4] = "NOEDIT";
  ComponentMode[ComponentMode["ALWAYSEDIT"] = 5] = "ALWAYSEDIT";
})(ComponentMode || (ComponentMode = {}));
export var ShowDefinedEntriesOnlyOpts;
(function (ShowDefinedEntriesOnlyOpts) {
  ShowDefinedEntriesOnlyOpts[ShowDefinedEntriesOnlyOpts["Toggle"] = 0] = "Toggle";
  ShowDefinedEntriesOnlyOpts[ShowDefinedEntriesOnlyOpts["No"] = 1] = "No";
  ShowDefinedEntriesOnlyOpts[ShowDefinedEntriesOnlyOpts["Yes"] = 2] = "Yes";
})(ShowDefinedEntriesOnlyOpts || (ShowDefinedEntriesOnlyOpts = {}));
export var Severity;
(function (Severity) {
  Severity["success"] = "success";
  Severity["info"] = "info";
  Severity["warning"] = "warning";
  Severity["error"] = "error";
})(Severity || (Severity = {}));
export const isUserType = item => {
  const {
    name,
    username,
    email
  } = item ?? {};
  return [name, username, email].every(v => typeof v === 'string');
};
export const isExpressionFunctionType = possibleEnumValue => Object.values(ExpressionFunctionType).includes(possibleEnumValue);
export { ComparisonType, ExpressionFunctionType };
export const isComparisonType = possibleEnumValue => Object.values(ComparisonType).includes(possibleEnumValue);
export var LogicalOperatorType;
(function (LogicalOperatorType) {
  LogicalOperatorType["AND"] = "and";
  LogicalOperatorType["OR"] = "or";
})(LogicalOperatorType || (LogicalOperatorType = {}));
export const isNullValueFilterPartType = filterPartType => filterPartType.predicate === ExpressionFunctionType.EXISTS;
export var DevicePoolType;
(function (DevicePoolType) {
  DevicePoolType["INVENTORY"] = "INVENTORY";
  DevicePoolType["ALLOCATION"] = "ALLOCATION";
})(DevicePoolType || (DevicePoolType = {}));
export var GatewayPoolType;
(function (GatewayPoolType) {
  GatewayPoolType["INVENTORY"] = "INVENTORY";
  GatewayPoolType["ALLOCATION"] = "ALLOCATION";
})(GatewayPoolType || (GatewayPoolType = {}));
export var ContextObjectType;
(function (ContextObjectType) {
  ContextObjectType["USER"] = "User";
  ContextObjectType["CUSTOMER"] = "Customer";
  ContextObjectType["NO_CONTEXT"] = "NO_CONTEXT";
  ContextObjectType["USER_SELECTED"] = "USER_SELECTED";
})(ContextObjectType || (ContextObjectType = {}));
export var AreaManagementMode;
(function (AreaManagementMode) {
  AreaManagementMode["ADD"] = "ADD";
  AreaManagementMode["EDIT"] = "EDIT";
})(AreaManagementMode || (AreaManagementMode = {}));